import React from 'react';
import PropTypes from 'prop-types';
import { LOGIN } from '../../../constants';
import alertIcon from 'assets/img/alert-icon.svg';
import moment from 'moment';

const POSITIONS = ['ver1', 'ver2', 'ver3', 'ver4', 'ver5', 'ver6'];

class VerificationCode extends React.Component {
  static propTypes = {
    handleGoback: PropTypes.func.isRequired,
    sendValidationCode: PropTypes.func.isRequired,
    validateCode: PropTypes.func.isRequired,
    setExpirationTime: PropTypes.func.isRequired,
    isResetError: PropTypes.bool,
    codeExpiration: PropTypes.object,
    sendMethod: PropTypes.shape({
      deliveryDestination: PropTypes.string,
      deliveryType: PropTypes.string,
      closeOppCount: PropTypes.string,
      userName: PropTypes.string
    })
  }

    state = {
      username: false,
      minutes: '',
      seconds: '',
      isCodeExpired: false,
      ver1: '',
      ver2: '',
      ver3: '',
      ver4: '',
      ver5: '',
      ver6: ''
    }

validationCodeTimer = () => {
  this.interval = setInterval(() => {
    const timeExpired = this.props.codeExpiration - moment();
    if (timeExpired < 0) {
      clearInterval(this.interval);
      this.setState({ isCodeExpired: true });
      return false;
    }
    const then = this.props.codeExpiration;
    const now = moment();
    const countdown = moment(then - now);
    const minutes = countdown.format('m');
    const seconds = countdown.format('ss');
    this.setState({ minutes, seconds });
  }, 1000);
}

componentDidMount () {
  this.validationCodeTimer();
}

  onKeyUp = (event) => {
    const key = event.keyCode || event.charCode;
    const isBackKey = key == 8 || key == 46;
    const position = POSITIONS.indexOf(event.target.name);
    const previousPosition = POSITIONS[position - 1];

    if (isBackKey) {
      this[previousPosition].focus();
    }
  }

    handleChange = (event) => {
      if (event.target.value.length <= 1) {
        this.setState({
          [event.target.name]: event.target.value
        });
      }

      const position = POSITIONS.indexOf(event.target.name);
      const nextPosition = POSITIONS[position + 1];

      if ((position >= 0) && (position < POSITIONS.length - 1) && (event.target.value !== '')) {
        this[nextPosition].focus();
      }

      if (event.target.value.length <= 1) {
        this.setState({ value: event.target.value });
      }
    }

    handleCodeResend = () => {
      const payload = {
        userName: this.props.sendMethod.userName,
        deliveryType: this.props.sendMethod.deliveryType,
        deliveryDestination: this.props.sendMethod.deliveryDestination

      };
      clearInterval(this.interval); // Prevent multiple intervals running simultaneously
      this.props.sendValidationCode(payload);
      this.props.setExpirationTime(moment().add(10, 'minutes'));
      this.validationCodeTimer();
      this.setState({ isCodeExpired: false });
    }

    componentWillUnmount = () => {
      clearInterval(this.interval);
    }

    SubmitVerificationCode = (event) => {
      event.preventDefault();
      const { ver1, ver2, ver3, ver4, ver5, ver6 } = this.state;
      const payload = {
        userName: this.props.sendMethod.userName,
        validationCode: ver1 + ver2 + ver3 + ver4 + ver5 + ver6
      };

      this.props.validateCode(payload);
    }

    render () {
      const deliveryId = this.props.sendMethod.deliveryDestination;
      const { ver1, ver2, ver3, ver4, ver5, ver6, minutes, seconds, isCodeExpired } = this.state;
      const remaingTime = minutes + ':' + seconds;
      return (
        <React.Fragment>
          <form className='login-content'>
            <div className='password-container'>
              <div className='login-bold-header'>
              Enter Your Verification Code
              </div>
              <div className='login-body-text'>
                <div>{`We've sent your code to ${deliveryId.replace(/(.{3})(.*)(?=@)/, '$1•••••')}`} </div>
                <div className='float-left'>{'Enter your code before it expires in '}<span className='req-alert'> {remaingTime}</span> </div>
              </div>
              <div className='input-code-wrapper'>
                <div className='input-code'>
                  <input autoFocus type='text' id='ver1' className='login-form login-code'
                    value={this.state.ver1} ref={ip1 => (this.ver1 = ip1)} name='ver1' autoComplete='off' onChange={this.handleChange} maxLength='1' />
                </div>
                <div className='input-code'>
                  <input type='text' id='ver2' className='login-form login-code' name='ver2' autoComplete='off'
                    onKeyUp={this.onKeyUp} value={this.state.ver2} ref={ip2 => (this.ver2 = ip2)} onChange={this.handleChange} maxLength='1' />
                </div>
                <div className='input-code'>
                  <input type='text' id='ver3' className='login-form login-code' name='ver3' autoComplete='off'
                    onKeyUp={this.onKeyUp} value={this.state.ver3} ref={ip3 => (this.ver3 = ip3)} onChange={this.handleChange} maxLength='1' />
                </div>
                <div className='input-code'>
                  <input type='text' id='ver4' className='login-form login-code' name='ver4' autoComplete='off'
                    onKeyUp={this.onKeyUp} value={this.state.ver4} ref={ip4 => (this.ver4 = ip4)} onChange={this.handleChange} maxLength='1' />
                </div>
                <div className='input-code'>
                  <input type='text' id='ver5' className='login-form login-code' name='ver5' autoComplete='off'
                    onKeyUp={this.onKeyUp} value={this.state.ver5} ref={ip5 => (this.ver5 = ip5)} onChange={this.handleChange} maxLength='1' />
                </div>
                <div className='input-code'>
                  <input type='text' id='ver6' className='login-form login-code' name='ver6' autoComplete='off'
                    onKeyUp={this.onKeyUp} value={this.state.ver6} ref={ip6 => (this.ver6 = ip6)} onChange={this.handleChange} maxLength='1' />
                </div>
              </div>
              { this.props.isResetError &&
              <div className='alert-message fade-in'>
                <div><img className='alert-icon' src={alertIcon} /></div>
                <div>{LOGIN.CODE_MATCH_ERROR}</div>
              </div>
              }
              { isCodeExpired &&
                <div className='alert-message fade-in'>
                  <div><img className='alert-icon' src={alertIcon} /></div>
                  <div>{LOGIN.CODE_EXPIRED_ERROR}</div>
                </div>
              }
              <div className='login-bottom-text center-align'>
                <div className='login-body-text'>Didn't get the code? <span className={'resend-text'} onClick={this.handleCodeResend}> Resend code </span></div>
              </div>
              <div className='login-bottom-text center-align login-assist'>
                <div>For assistance over the phone please call: </div>
                <div><a href='tel:(844)-326-2873'>(844)-326-2873</a></div>
              </div>
            </div>
            <div className='bottom-button-wrapper'>
              <div>
                <button onClick={this.props.handleGoback} className='login-back-btn' type='reset'>
                   Back
                </button>
              </div>
              <div className=' push'>
                <button disabled={!(ver1, ver2, ver3, ver4, ver5, ver6, !isCodeExpired)}
                  onClick={this.SubmitVerificationCode} className='login-primary-button' type='submit'>
                  Verify
                </button>
              </div>
            </div>
          </form>
        </React.Fragment>
      );
    }
}

export default VerificationCode;
